import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "src/components/Header";
import Loader from "@elsa-zku/lib/components/Loader";
import { useBuildings } from "src/store/buildings";
import { useUser } from "src/store/user";

type Props = {
  children: () => JSX.Element,
};

export default function UserAuthGuard(props: Props): JSX.Element {
  const { isAuth } = useUser();
  const location = useLocation();
  const { buildingsList } = useBuildings();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuth === false && location.pathname !== "/login") navigate("/login");
  }, [isAuth, location]);

  if (!isAuth || !buildingsList) return <Loader />;
  return (
    <>
      <Header />
      {props.children()}
    </>
  );
};
